// utils/speechUtils.js

/**
 * Customizes and executes Text-to-Speech
 * @param {string} text - The content to speak
 * @param {object} options - Customization for voice and tonality
 * @param {function} onEnd - Callback when speech finishes
 */
export const speak = (text, options = {}, onEnd = () => {}) => {
  // Cancel any ongoing speech to prevent overlapping
  window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(text);

  // --- TONALITY CONFIGURATION ---
  // Rate: 0.1 to 10 (1 is normal). Lower is slower/more serious, higher is faster.
  utterance.rate = options.rate || 1.0; 
  
  // Pitch: 0 to 2 (1 is normal). Lower is deeper/authoritative, higher is squeaky/energetic.
  utterance.pitch = options.pitch || 1.0; 
  
  // Volume: 0 to 1
  utterance.volume = options.volume || 1.0; 

  // --- VOICE SELECTION ---
  const voices = window.speechSynthesis.getVoices();
  
  // Example: Preference for a specific system voice (e.g., 'Google US English')
  // Different browsers/OS have different available voices
  const preferredVoice = voices.find(v => v.name.includes(options.voiceName || 'Google English (India)')) 
                        || voices[0];
  
  if (preferredVoice) {
    utterance.voice = preferredVoice;
  }

  utterance.onend = onEnd;
  utterance.onerror = (err) => console.error("SpeechSynthesis Error:", err);

  window.speechSynthesis.speak(utterance);
};

export const stopSpeech = () => {
  window.speechSynthesis.cancel();
};